export default __webpack_public_path__ + "static/media/pictogramBeaconClock128.7fc8dee7.svg";